import awaitWrap from '../../../procedures/await-wrap';
import destroyConfirm from '../../../procedures/destroy-confirm';
import httpWrap from '../../../procedures/http-wrap';
import action from '../../abstract/action.js';

const handle = async (
  {
    $vs,
    item,
    reloadList,
    model: {
      api: {
        softDelete,
      },
      vars: {
        softDelete: {
          title,
          text,
          successText,
        },
      },
    },
  },
) => {
  await destroyConfirm({
    $vs,
    title: await awaitWrap(title)(item),
    text: await awaitWrap(text)(item),
    action: async () => await httpWrap({
      $vs,
      action: softDelete,
      success: { text: successText },
      onSuccess: reloadList,
    })(item),
  });
};

export default action({
  label: 'Usuń',
  icon: 'TrashIcon',
  main: () => false,
  handle,
});
